module.exports = __webpack_public_path__ + "img/LUB00396.662296aa.png";